/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-param-reassign */
import { toPascalCase } from 'UTILS/string';
import wait from 'UTILS/wait';
import pdpCarousel from './product-carousel';

const productImageWrappers = document.querySelectorAll('[data-id="product-image-pdp"]');

let productImageWrappersCarousel = document.querySelectorAll(
  '[data-id="product-image-carousel-pdp"]'
);
const productImagesContainer = document.querySelector('[data-id="product-page-images"]');
const carouselContainer = document.querySelector('[data-id="product-page-images-small"]');
const carouselImagesContainer = document.querySelector('[data-id="product-carousel-wrapper"]');

const transitionDuration = 300; // matches css, less problematic to hardcode than getComputedStyle

let imageLoadedCount = 0;
let totalNewPdpImages = 0;
let currentColor = '';
let imageLoadedTimer = 0;

const MAX_IMAGES = 6;

const imgTagData = {
  desktop: {
    classes: '',
    dataset: null,
  },
  carousel: {
    classes: '',
    dataset: null,
  },
};

function setImgTagData() {
  const wrapperData = [
    { type: 'desktop', wrappers: productImageWrappers },
    { type: 'carousel', wrappers: productImageWrappersCarousel },
  ];
  wrapperData.forEach(({ type, wrappers }) => {
    const img = wrappers && wrappers[0] && wrappers[0].children && wrappers[0].children[0];
    if (img) {
      const { className, dataset } = img;
      imgTagData[type].classes = className;
      imgTagData[type].dataset = dataset;
    }
  });
}

function handleImageLoaded(event) {
  imageLoadedCount += 1;
  event.target.removeEventListener('load', handleImageLoaded, true); // otherwise they stack up when the variant changes
  if (imageLoadedCount >= totalNewPdpImages) {
    const timeElapsedMs = Math.floor(Date.now() - imageLoadedTimer);
    if (timeElapsedMs < 200) {
      setTimeout(() => productImagesContainer.classList.add('u-opacityShown'), 600);
    } else {
      productImagesContainer.classList.add('u-opacityShown');
    }

    imageLoadedCount = 0;
  }
}

function initImageListeners() {
  try {
    const images = [];
    productImageWrappers.forEach((item) => {
      const image = item.children[0];
      if (image) images.push(image);
    });
    totalNewPdpImages = images.length;
    images.forEach((image) => {
      if (image.complete) {
        imageLoadedCount += 1;
        if (imageLoadedCount === totalNewPdpImages) {
          productImagesContainer.classList.add('u-opacityShown');
        }
      } else if (imageLoadedCount === totalNewPdpImages) {
        productImagesContainer.classList.add('u-opacityShown');
      } else {
        image.addEventListener('load', handleImageLoaded, true);
      }
    });
  } catch (error) {
    productImagesContainer.classList.add('u-opacityShown');
  }
}

function getTagData(arr) {
  const src = arr[0];
  const alt = arr[1];
  return { src, alt };
}

function setImg({ img, src, alt, isMobile }) {
  const key = isMobile ? 'carousel' : 'desktop';
  img.src = src;
  img.alt = alt;
  img.className = imgTagData[key].classes;
  img.srcset = `${src};width=375 375w,${src};width=550 550w`;
  const { dataset } = imgTagData[key];
  if (dataset) {
    for (const attr in dataset) {
      img.dataset[attr] = dataset[attr];
    }
  }
}

async function handleDesktopImagesUpdate(imageData) {
  imageLoadedTimer = Date.now();
  totalNewPdpImages = imageData.length;
  if (totalNewPdpImages === 0) return;
  productImagesContainer.classList.remove('u-opacityShown'); // fade out
  // match wait with css transitions anim
  await wait(transitionDuration);
  productImageWrappers.forEach((el, i) => {
    let img = el.children[0];
    if (imageData[i]) {
      if (!img) {
        img = new Image();
        el.appendChild(img);
      }
      const { src, alt } = getTagData(imageData[i]);
      setImg({ img, src, alt });
      if (img.completed) {
        imageLoadedCount += 1;
        return;
      }
      img.addEventListener('load', handleImageLoaded, true);
    } else if (img) {
      // new variant has fewer images, remove old images
      img.remove();
    }
  });
}

async function handleCarouselImagesUpdate(imageData) {
  if (!imageData || imageData.length === 0) return;
  carouselContainer.classList.add('u-opacityHidden');
  await wait(transitionDuration);
  const elCount = productImageWrappersCarousel.length;
  productImageWrappersCarousel.forEach((el, i) => {
    const img = el.children[0];
    if (imageData[i]) {
      const { src, alt } = getTagData(imageData[i]);
      setImg({ img, src, alt, isMobile: true });
    } else if (img) {
      // new variant has fewer images, remove el
      el.remove();
    }
  });
  if (imageData.length > elCount) {
    // add some elements
    // eslint-disable-next-line no-plusplus
    for (let step = 0; step < imageData.length - elCount; step++) {
      const el = productImageWrappersCarousel[0].cloneNode(true);
      const img = el.children[0] || {};
      const imageIndex = elCount + step;
      const { src, alt } = getTagData(imageData[imageIndex]);
      setImg({ img, src, alt, isMobile: true });
      carouselImagesContainer.appendChild(el);
    }
  }
  if (pdpCarousel) {
    pdpCarousel.updateSlides();
    pdpCarousel.slideTo(0, 0, false);
  }
  productImageWrappersCarousel = document.querySelectorAll(
    '[data-id="product-image-carousel-pdp"]'
  );
  await wait(200); // allow some time for new images to load
  carouselContainer.classList.remove('u-opacityHidden');
}

function getImageDataFromVariant(variantColor) {
  return window.ProductMedia.map((item) => {
    if (item.alt && item.alt.includes(`(${variantColor})`)) {
      if (!item.src) return null;
      return [item.src, item.alt];
    }
    return null;
  })
    .filter(Boolean)
    .slice(0, MAX_IMAGES);
}

// eslint-disable-next-line import/prefer-default-export
export async function updateImages({ selectedVariant }) {
  const variantColor = toPascalCase(selectedVariant.option1).replace(/ /g, '');
  if (currentColor !== variantColor) {
    const imageData = getImageDataFromVariant(variantColor);
    // switch the images
    handleDesktopImagesUpdate(imageData);
    handleCarouselImagesUpdate(imageData);

    currentColor = variantColor;
  }
}

export function initCurrentColor({ selectedVariant }) {
  currentColor = toPascalCase(selectedVariant.option1).replace(/ /g, '');
}

setImgTagData();
initImageListeners();
